import React from "react";
import {makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import clsx from "clsx";
import Tr from 'translations/Translations';
import ContractorVerificationRow from "./ContractorVerificationRow";

const useStyles = makeStyles(theme => ({
    table: {
        tableLayout: 'fixed',

        '& td, th': {
            overflow: 'hidden',
        }
    },
    lpColumn: theme.components.table.lpColumn,
    statusColumn: {
        width: 300,
        paddingRight: theme.spacing(2)
    },
}));

function ContractorVerificationTable(
    {
        contractorList,
        contractorVerificationProcedure,
        working,
        editable,
        demandId
    }) {

    const classes = useStyles();

    return (<TableContainer>
        <Table className={clsx(classes.table)}>
            <TableHead>
                <TableRow>
                    <TableCell className={classes.lpColumn}>{Tr("column_lp")}</TableCell>
                    <TableCell>{Tr("contractor")}</TableCell>
                    <TableCell className={classes.statusColumn}>{Tr("contractor_status")}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {contractorList.items.map((contractorElem, index) =>
                    <ContractorVerificationRow
                        key={contractorElem.contractor.identity}
                        contractorElem={contractorElem}
                        contractorVerificationProcedure={contractorVerificationProcedure}
                        index={index}
                        working={working}
                        editable={editable && contractorElem.editable}
                        demandId={demandId}
                    />
                )}
            </TableBody>
        </Table>
    </TableContainer>)
}

export default ContractorVerificationTable;

